import { useCallback, useState } from 'react';

export const useFaqAccordion = (initialId: string) => {
  const [openId, setOpenId] = useState(initialId);

  const toggle = useCallback((id: string) => {
    setOpenId((currentId) => (currentId === id ? '' : id));
  }, []);

  return { openId, toggle };
};
